<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
  >
    <div :class="{'validation-failed':failed}">
      <item-name :item="item" />
      <div class="relative">
        <select
          v-model="value"
          :name="itemName"
          class="pl-4 pr-12 py-4 bg-gray-800 text-gray-100 w-full appearance-none rounded-none outline-none border-3 border-transparent focus:border-orange-700"
        >
          <option :value="null">
            Please select an option
          </option>
          <option
            v-for="option in options"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
        <div class="absolute right-0 top-0 flex items-center h-full mr-3 pointer-events-none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 512"
            class="h-6 w-6 text-gray-500"
          >
            <path
              fill="currentColor"
              d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
            />
          </svg>
        </div>
      </div>
    </div>
  </validation-provider>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'

export default {
  components: {
    ItemName
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    options () {
      let options = this.item.meta.options
      return options.sort((a, b) => a.order - b.order)
    }
  }
}
</script>
